import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GetAllRoles, GetNotifications, UpdateNotificationSetting, AddRemoveNotificationSetting, GetNewNotifications } from '../store/notifications.actions';
import { LoaderShow } from 'src/app/features/loader/store/loader.actions';
import { Location } from '@angular/common';


@Component({
    selector: 'app-manage-notifications',
    templateUrl: './manage-notifications.component.html',
    styleUrls: ['./manage-notifications.component.scss']
})
export class ManageNotificationsComponent implements OnInit {
    manageNotifsForm: FormGroup;
    notificationsOfRoles: Array<any> = [];
    rolesList: Array<any> = [' '];
    tableHeaderList;
    notificationScenarios: Array<any> = [];
    dataObj: any;
    finalList: Array<any> = [];
    targetId: string;
    groupArr: Array<any> = [];

    constructor(
        private store: Store<AppState>,
        private router: Router,
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private location: Location
    ) { }

    ngOnInit() {
        this.manageNotifsForm = this.fb.group({
            role: []
        });

        this.store.dispatch(new LoaderShow());
        this.store.dispatch(new GetAllRoles());
        this.store.select(state => state.notifications.roles).subscribe((roles) => {
            this.rolesList = roles;
            if (this.rolesList.filter(role => role.role.includes('empty')).length === 0) {
                this.rolesList.unshift({
                    role: 'empty',
                    description: ''
                });
            }

            this.tableHeaderList = (this.rolesList||[]).map(role => role.role);
        })

         this.store.dispatch(new GetNotifications());

        // this.store.select(state => state.notifications.notifList).subscribe((response) => {
        //     this.finalList = [];
        //     this.notificationsOfRoles = response['data'];
        //     this.notificationScenarios = response['notificationScenarios'];

        //     if (typeof this.notificationScenarios == "undefined" || typeof this.notificationsOfRoles == "undefined") {
        //         return;
        //     }

        //     this.notificationScenarios.map(type => {
        //         this.dataObj = {};
        //         this.dataObj[type] = [];

        //         this.rolesList.forEach(role => {
        //             const roleTemplate = {};
        //             this.notificationsOfRoles.map((item: any) => {
        //                 roleTemplate[item.role] = item.templates;
        //                 return roleTemplate;
        //             });
        //             if (role.role === 'empty') {
        //                 this.dataObj[type].push(type);
        //             }
        //             else {
        //                (roleTemplate[role.role]||[]).map(template => {
        //                     if (template.displayName == type) {
        //                         this.dataObj[type].push(template);
        //                     }
        //                 })
        //             }

        //             role['emailSelectAll'] = false;
        //             role['smsSelectAll'] = false;

        //         });
        //         this.finalList.push(this.dataObj);
        //     });



        //     this.rolesList.forEach((role, roleIndex) => {
        //         var notificationsOfRolesIndex = this.notificationsOfRoles.findIndex(x => x.role === role.role);
        //         if (notificationsOfRolesIndex >= 0) {  
        //             this.setRoleSelectAll(roleIndex, notificationsOfRolesIndex, 'all')
        //         };
        //     });

        //     console.log(this.finalList);
            
        // });

        this.store.dispatch(new GetNewNotifications());
        this.store.select(state => state.notifications.notifNewList).subscribe((response) => {
            this.finalList = [];
            this.notificationsOfRoles = response['data'];
            this.notificationScenarios = response['notificationScenarios'];

            if (typeof this.notificationScenarios == "undefined" || typeof this.notificationsOfRoles == "undefined") {
                return;
            }

            let objValue = Object.values( this.notificationScenarios);
            let objKey = Object.keys( this.notificationScenarios);

            const result = [].concat(...Object.values(this.notificationScenarios));

            result.map(type => {
                this.dataObj = type;
                this.dataObj['templates'] = [];
                this.dataObj['templates'] = [];

                this.rolesList.forEach(role => {
                    const roleTemplate = {};
                    this.notificationsOfRoles.map((item: any) => {
                        roleTemplate[item.role] = item.templates;
                        return roleTemplate;
                    });
                    if (role.role === 'empty') {
                        this.dataObj['templates'].push(type.template);
                    }
                    else {
                       (roleTemplate[role.role]||[]).map(template => {
                            if (template.displayName == type.template) {
                                this.dataObj['templates'].push(template);
                            }
                        })
                    }

                    role['emailSelectAll'] = false;
                    role['smsSelectAll'] = false;


                });
                this.finalList.push(this.dataObj);
            });

            this.groupArr = this.finalList.reduce((r,{category})=>{
                if(!r.some(o=>o.category==category)){
                  r.push({viewStatus:'true',category,templates:this.finalList.filter(v=>v.category==category)});
            }
            return r;
            },[]);


            this.rolesList.forEach((role, roleIndex) => {
                var notificationsOfRolesIndex = this.notificationsOfRoles.findIndex(x => x.role === role.role);

                if (notificationsOfRolesIndex >= 0) {  
                    this.setRoleSelectAll(roleIndex, notificationsOfRolesIndex, 'all');
                };
            });
        });
    }


    getElementValue(element) {
        // console.log(Object.keys(element).length > 0 ? element[Object.keys(element)[0]] : []);
        return Object.keys(element).length > 0 ? element[Object.keys(element)[0]] : [];
    }

    getElementKey(element) {
        return Object.keys(element).length > 0 ? Object.keys(element)[0] : '';
    }

    saveNotificatiosArray = [];

    saveNotification(event, template, roleIndex, type) {
        let role = this.rolesList[roleIndex+1];
        var result = this.notificationsOfRoles.findIndex(x => x.role === role.role);
        var templateName = template.templateName;

        this.checkNotifications(result, templateName,  event.currentTarget.checked, type)
        this.saveNotificationArray(role, result);
        this.markSelectAll(event.currentTarget.checked, role, result, type);
    }


    submitNotifications(){
        if (this.saveNotificatiosArray.length === 0) {
            return;
        }
        this.store.dispatch(new LoaderShow());
        const payload = { data: this.saveNotificatiosArray };
        this.store.dispatch(new AddRemoveNotificationSetting(payload));
    }

    setRoleSelectAll(roleListIndex, notificationsOfRoleIndex, type){
        let trueCountEmail = 0;
        let trueCountMobile = 0;

        this.notificationsOfRoles[notificationsOfRoleIndex].templates.forEach(element => {
            if (type == "email") {
                if (element.email) {
                    trueCountEmail ++; 
                }
            } else if (type == "mobile") {
                if (element.mobile) {
                    trueCountMobile ++; 
                }
            } else {
                if (element.email) {
                    trueCountEmail ++; 
                }

                if (element.mobile) {
                    trueCountMobile ++; 
                }
            }
        });

        if (trueCountEmail == this.notificationsOfRoles[notificationsOfRoleIndex].templates.length) {
            this.rolesList[roleListIndex].emailSelectAll =  true;
        }

        if (trueCountMobile == this.notificationsOfRoles[notificationsOfRoleIndex].templates.length) {
            this.rolesList[roleListIndex].smsSelectAll =  true;
        }
    }

    checkNotifications(notificationsOfRolesIndex, templateName, checkStatus, type ){
        var templateArrayIndex = this.notificationsOfRoles[notificationsOfRolesIndex].templates.findIndex(x => x.templateName === templateName);

        if (type == "email") {
            this.notificationsOfRoles[notificationsOfRolesIndex].templates[templateArrayIndex].email = checkStatus;
        }
        else {
            this.notificationsOfRoles[notificationsOfRolesIndex].templates[templateArrayIndex].mobile = checkStatus;
        }
    }


    saveNotificationArray(role, notificationsOfRolesIndex){
        var saveArrayIndex = this.saveNotificatiosArray.findIndex(x => x.role === role.role);
        if (saveArrayIndex >= 0  ) {
            this.saveNotificatiosArray.splice(saveArrayIndex, 1);
            this.saveNotificatiosArray.push(this.notificationsOfRoles[notificationsOfRolesIndex]);
        } else {
            this.saveNotificatiosArray.push(this.notificationsOfRoles[notificationsOfRolesIndex]);
        }
    }


    selectDeselectAll(event, role, colIndex, type){
        let status = event.currentTarget.checked;

        var notificationsOfRolesIndex = this.notificationsOfRoles.findIndex(x => x.role === role.role);
        this.notificationsOfRoles[notificationsOfRolesIndex].templates.forEach((item, itemIndex) => {
            if (type == "email") {
                this.notificationsOfRoles[notificationsOfRolesIndex].templates[itemIndex].email = status;
            }
            else {
                this.notificationsOfRoles[notificationsOfRolesIndex].templates[itemIndex].mobile = status;
            }
        });

        this.saveNotificationArray(role, notificationsOfRolesIndex);
        var roleArrayIndex = this.rolesList.findIndex(x => x.role === role.role);
        if (type == "email") {
            this.rolesList[roleArrayIndex].emailSelectAll =  status;
        } else {
            this.rolesList[roleArrayIndex].smsSelectAll =  status;
        }


        this.groupArr = this.finalList.reduce((r,{category})=>{
            if(!r.some(o=>o.category==category)){
                r.push({category,templates:this.finalList.filter(v=>v.category==category)});
            }
        return r;
        },[]);
    }

    cancel() {
        // to refresh the current component
        this.router.navigateByUrl('/home/user-management/users-list', { skipLocationChange: true }).then(() => {
            this.router.navigate(["home", "notifications", "manage-notifications"]);
        });
    }

    markSelectAll(eventChecked, role, notificationsOfRolesIndex, type ){
        var roleArrayIndex = this.rolesList.findIndex(x => x.role === role.role);
        if (eventChecked) {
            this.setRoleSelectAll(roleArrayIndex, notificationsOfRolesIndex, type);
        } else {
            if (type == "email") {
                this.rolesList[roleArrayIndex].emailSelectAll =  false;
            }
            else {
                this.rolesList[roleArrayIndex].smsSelectAll =  false;
            }
        }
    }


    toggleView(colDataIndex){
        this.groupArr[colDataIndex].viewStatus = !this.groupArr[colDataIndex].viewStatus;
    }


}
